import {ChangeDetectorRef, Injectable} from '@angular/core';
import {HttpService} from "./http.service";
import {BehaviorSubject, Observable} from "rxjs";
import {Pagination} from "../models/pagination.model";
import {WithdrawRial} from "../models/withdraw-rial.model";
import {map, skip, take} from "rxjs/operators";
import {TransactionType, UserTransaction} from "../models/user-transaction.model";

@Injectable({
  providedIn: 'root'
})
export class UserTransactionService {
  constructor(private http: HttpService) {
  }

  getUserTransactionList(
    userId: number[],
    page: number,
    limit = 15,
    market: string
  ): Observable<Pagination<UserTransaction>> {
    return this.http
      .request('post', '/v2/admin/transaction', {
        user_id_included: [userId],
        page,
        limit,
        market
      })
      .pipe(
        map((response: any) => {
          response.data = response.data?.map((order: any) => new UserTransaction(order));
          return response;
        }),
        map((response) => new Pagination<UserTransaction>(response))
      );
  }
}
